/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios";

const getAddressFromZipcode = async (zipcode: number | string | undefined) => {
  return axios.get(`https://viacep.com.br/ws/${zipcode}/json`);
};

export default getAddressFromZipcode;
